var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stat',{attrs:{"title":_vm.$t('dashboard.averagetimespent.title'),"loading":_vm.loading}},[(_vm.totalResults !== 0)?_c('average-time-chart',{staticStyle:{"width":"100%"},attrs:{"dataKey":_vm.dataKey,"height":200,"params":_vm.params,"lazy":""}}):_c('small',[_vm._v(_vm._s(_vm.$t('dashboard.averagetimespent.notActivated')))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5978097c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/AverageTimeSpent.vue
// module id = null
// module chunks = 